module.exports = __webpack_public_path__ + "static/media/doctorImage.b81ef920.svg";